import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import { sectorImages } from '../../constants/images';
import '../../styles/sections/sectorMain.css';

const SectorMain = ({ motionProps }) => {
  return (
    <section className="section_container bg_img_sec top_banner_sec" id="top_banner_sec">
      <motion.div 
        className="grid"
        {...motionProps}
      >
        {/* <div className="space_before_sec_title"></div> */}
        <p className="sec_title">
          <img src={sectorImages.main.title1.pc} className="pc_viewer" alt="" />
          <img src={sectorImages.main.title1.mobile} className="mo_viewer margin_top_mobile" alt="" />
        </p>
        <p className="sec_title">
          <img src={sectorImages.main.title2.pc} className="pc_viewer" alt="" />
          <img src={sectorImages.main.title2.mobile} className="mo_viewer margin_top_mobile" alt="" />
        </p>
        <p className="sec_title">
          <img src={sectorImages.main.title3.pc} className="pc_viewer" alt="" />
          <img src={sectorImages.main.title3.mobile} className="mo_viewer margin_top_mobile" alt="" />
        </p>
        
      <div className="btn_wrapper_sector_main">
        <div className="apply_btn">
          <Link to="/apply">
            <img src={sectorImages.main.button.pc} className="pc_viewer" alt="" />
            <img src={sectorImages.main.button.mobile} className="mo_viewer" alt="" />
          </Link>
        </div>
      </div>
      </motion.div>
    </section>
  );
};

SectorMain.propTypes = {
  motionProps: PropTypes.shape({
    initial: PropTypes.object,
    whileInView: PropTypes.object,
    exit: PropTypes.object,
    viewport: PropTypes.object,
    transition: PropTypes.object
  }).isRequired
};

export default SectorMain; 